import { C } from '../../theme/palette';

/**
 * Barre d'onglets, dessinée comme la maquette V288 : les onglets qui ne
 * tiennent pas sur une ligne passent à la suivante, rien n'est caché hors de
 * l'écran.
 *
 * <p>Chaque onglet est un vrai bouton, annoncé comme onglet : il se prend au
 * clavier sans rien changer au dessin.
 */
export const Tabs = ({ items, active, onChange }) => (
  <div
    role="tablist"
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 3,
      background: C.white,
      borderRadius: 10,
      padding: 4,
      border: '1px solid ' + C.border,
    }}
  >
    {items.map(([id, lb]) => {
      const on = active === id;
      return (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={on}
          onClick={() => onChange(id)}
          style={{
            flexShrink: 0,
            padding: '7px 11px',
            border: 'none',
            borderRadius: 7,
            fontSize: 9.5,
            fontWeight: 700,
            lineHeight: 'normal',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            background: on ? C.navy : 'transparent',
            color: on ? '#fff' : C.grey,
          }}
        >
          {lb}
        </button>
      );
    })}
  </div>
);
